export class GiftCardApplyError extends Error {
    constructor(message: string = 'Подарочный сертификат не найден') {
        super(message);
        this.name = 'GiftCardApplyError';
    }
}
